/**
 * The label for a booking's `comment` on the detail and edit pages.
 *
 * `order.comment` holds two different things depending on who made the
 * booking: on a booking an admin created it is the admin's internal note; on
 * a booking the customer made in the booking app it is the customer's own
 * note ("Zusätzliche Anmerkungen"). Labelling both "Interner Kommentar" told
 * the operator a customer's words were their own team's.
 *
 * `createdBy` is the order's `created_by` (`user` | `admin` | `any` | `auto`),
 * carried by `GET order/{orderId}/room-rental` as `createdBy`. Anything other
 * than `user` / `admin` — including an absent field from an older backend —
 * gets the neutral label: never claim "internal" when we do not know.
 *
 * Create pages do not use this: whoever fills the form there is the admin, so
 * they keep `create_booking.customer_details.comment`. Neither does the
 * station (non-room) booking page: no end-user station flow writes a comment,
 * so there the field is always the admin's note — even on a booking the
 * customer made. Only the room/venue flow sends the customer's remarks
 * (apps/end-user createVenueReservationFlow).
 */
export const commentLabelKey = (createdBy: string | null | undefined): string => {
    switch ((createdBy ?? '').toLowerCase()) {
        case 'user':
            return 'create_booking.customer_details.comment_customer';
        case 'admin':
            return 'create_booking.customer_details.comment';
        default:
            return 'create_booking.customer_details.comment_unknown_origin';
    }
};
